import { SOCKET_EVENTS } from "@markedesk/core-contracts";

/**
 * Assina a presença dos atendentes (#4433).
 *
 * Fora do componente porque é lógica com regra: quem entra na lista, quem só
 * muda de estado, e o `off` com o MESMO handler. Antes isto vivia dentro de um
 * hook que ninguém chegava a chamar — e o `off` era por NOME de evento, que
 * remove todos os ouvintes, inclusive os de outra tela.
 *
 * Nomes dos eventos sempre do core-contracts: string digitada dos dois lados é
 * como o typo do `quickemessage` deixou o tempo-real morto por meses.
 *
 * @returns função de limpeza para o `useEffect`.
 */
export function subscribePresence(socket, setUsers) {
  if (!socket) return () => {};

  const aoReceberLista = (users) => setUsers(Array.isArray(users) ? users : []);

  const marcar = (online) => (payload) => {
    const userId = payload?.userId;
    if (userId === undefined || userId === null) return;
    setUsers((prev) => aplicarEstado(prev, userId, online, payload?.lastSeen));
  };

  const aoEntrarUsuario = (payload) => {
    const user = payload?.user;
    if (!user) return;
    setUsers((prev) => adicionar(prev, user));
  };

  const aoFicarOnline = marcar(true);
  const aoFicarOffline = marcar(false);

  socket.on(SOCKET_EVENTS.PRESENCE.ONLINE_LIST, aoReceberLista);
  socket.on(SOCKET_EVENTS.PRESENCE.USER_ONLINE, aoFicarOnline);
  socket.on(SOCKET_EVENTS.PRESENCE.USER_OFFLINE, aoFicarOffline);
  socket.on(SOCKET_EVENTS.PRESENCE.USER_NEW, aoEntrarUsuario);

  return () => {
    socket.off(SOCKET_EVENTS.PRESENCE.ONLINE_LIST, aoReceberLista);
    socket.off(SOCKET_EVENTS.PRESENCE.USER_ONLINE, aoFicarOnline);
    socket.off(SOCKET_EVENTS.PRESENCE.USER_OFFLINE, aoFicarOffline);
    socket.off(SOCKET_EVENTS.PRESENCE.USER_NEW, aoEntrarUsuario);
  };
}

/**
 * Muda o estado de um atendente que já está na lista.
 *
 * Quem não está na lista NÃO é inserido aqui: o evento de mudança não traz nome
 * nem foto, e uma linha sem nome apareceria na tela. Quem chega de verdade vem
 * pelo USER_NEW, que traz o usuário inteiro.
 */
export function aplicarEstado(users, userId, online, lastSeen) {
  const i = users.findIndex((u) => u.id === userId);
  if (i === -1) return users;
  const copia = [...users];
  copia[i] = { ...copia[i], online, lastSeen };
  return copia;
}

/** Acrescenta quem entrou, sem duplicar quem já estava. */
export function adicionar(users, user) {
  if (users.some((u) => u.id === user.id)) return users;
  return [...users, { ...user, online: true }];
}
